import { useLocalStorage } from '@flipster/react/misc/state/use-local-storage';

export function useOrderTutorialV2NewFeatureTooltip() {
  return useLocalStorage({
    /**
     * Bump configs version when new features are stored in onboarding tutorial modal
     */
    key: 'flipster.configs.v1.order_tutorial_v2_new_feature_tooltip',
    defaultValue: true,
  });
}
